import React from 'react';

const MatchingView = () => {
    return (
        <div className="min-h-screen bg-white flex items-center justify-center">
            <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md w-full">
                <h2 className="text-2xl font-semibold mb-6">
                    Finding your ideal hiking buddy...
                </h2>
                
                <div className="flex justify-center mb-6">
                    <div className="w-12 h-12 border-4 border-[#6B01D1] border-t-transparent rounded-full animate-spin"></div>
                </div>
                
                <p className="text-gray-600">
                    Please wait while we find the best match for you.
                </p>
            </div>

            <style jsx="true">{`
                @keyframes spin {
                    to {
                        transform: rotate(360deg);
                    }
                }
                .animate-spin {
                    animation: spin 1s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default MatchingView; 